import { SimpleSlider } from "../../../elements/SimpleSlider/SimpleSlider";
import { WelcomeStyles } from "./style";
import type React from "react";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import {
  Paragraph,
  RoundButton,
  Scrollbar,
  TextSizes,
} from "@smartsuite/react-ui/lib";

interface Slide {
  id: number;
  title: React.ReactElement;
  subtitle: string;
}

export const WelcomeAutomationsContent = observer<Record<string, never>>(() => {
  const slides: Slide[] = makeSlides();

  const navigate = useNavigate();

  const addAutomation = (): void => {
    navigate("/create");
  };

  // show Create my first Automation page only once for user.
  if (localStorage.getItem("hide-my-first-automation-modal") !== null) {
    addAutomation();
  }

  return (
    <WelcomeStyles>
      <Scrollbar
        classes="welcome-automation-content"
        noScrollX
        gutterTop={10}
        gutterBottom={10}
        gutterRight={5}
        contentProps={{ style: { display: "block" } }}
        translateContentSizeYToHolder
      >
        <div className="welcome-automation-content-wrapper">
          <div className="welcome-automation-content-inner">
            <SimpleSlider
              slidesToShow={1}
              dots={true}
              arrows={false}
              slidesContent={slides}
              autoplay={true}
              autoplaySpeed={5000}
            />
            <div className="welcome-text">
              <Paragraph color={"primary"} size={"l"} align={"center"}>
                {t("automation-list.welcome-text")}
              </Paragraph>
            </div>
            <div>
              <RoundButton
                styles={{
                  height: 40,
                  sidePadding: 30,
                  textSize: TextSizes.XL,
                  textWeight: "medium",
                }}
                className="create-first-button"
                onClick={addAutomation}
              >
                {t("automation-list.create-first-automation-button")}
              </RoundButton>
            </div>
          </div>
        </div>
      </Scrollbar>
    </WelcomeStyles>
  );
});

const makeSlides = (): Slide[] => [
  {
    id: 0,
    subtitle: t("automation-list.change-assignment"),
    title: (
      <span>
        {t("general.when")} <strong>Status</strong>
        {` ${t("general.change.other")} ${t("general.to")} `}
        <strong>“Ready for Review”</strong>,{` ${t("general.change.one")} `}
        <strong>Assigned To</strong>
        {` ${t("general.to")} `}
        <strong>“Jon Doe”</strong>
      </span>
    ),
  },
  {
    id: 1,
    subtitle: t("automation-list.notify-record-owner"),
    title: (
      <span>
        {t("general.when")} <strong>Date</strong>
        {` ${t("welcome-slides.arrives")}, ${t("welcome-slides.notify")} `}
        <strong>Owner</strong>
      </span>
    ),
  },
  {
    id: 2,
    subtitle: t("automation-list.change-priority"),
    title: (
      <span>
        {t("general.when")} <strong>Date</strong>
        {` ${t("welcome-slides.arrives")}, ${t("general.change.one")} `}
        <strong>Priority</strong>
        {` ${t("general.to")} `}
        <strong>“High”</strong>
      </span>
    ),
  },
  {
    id: 3,
    subtitle: t("automation-list.send-message-slack"),
    title: (
      <span>
        {t("general.when")} <strong>Priority</strong>
        {` ${t("welcome-slides.changes-to")} `}
        <strong>High</strong>
        {` ${t("welcome-slides.send-slack-message")} `}
        <strong>#Marketing</strong>
        {` ${t("welcome-slides.channel")}`}
      </span>
    ),
  },
  {
    id: 4,
    subtitle: t("automation-list.create-new-record"),
    title: (
      <span>
        {`${t("welcome-slides.when-an")} `}
        <strong>Email</strong>
        {` ${t("welcome-slides.is-received")}, `}
        <strong>{t("general.create")}</strong>
        {` ${t("welcome-slides.new-record-in")} `}
        <strong>Sales Leads</strong>
      </span>
    ),
  },
];
